/**
 * Merge fresh fields into an existing post list by id, keeping the existing
 * length and order. Used by the silent "returning" refreshes: because nothing
 * is added, removed, or reordered, a restored scroll position cannot jump.
 * Genuinely new posts surface on the next full fetch instead.
 */
const mergeResultsById = <T extends { id: string }>(existing: T[], fresh: T[]): T[] => {
  const byId = new Map(fresh.map((item) => [item.id, item]));
  return existing.map((item) => (byId.has(item.id) ? { ...item, ...byId.get(item.id) } : item));
};

export default mergeResultsById;
